




































import { Component, Prop } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import ComponentVue from "@/app/core/window/ComponentVue";
import { WindowInfo } from "@/@types/window";
import VueEvent from "@/app/core/decorator/VueEvent";
import LanguageManager from "@/LanguageManager";

@Component
export default class ChatInputInfoComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: Object, required: true })
  private windowInfo!: WindowInfo<any>;

  @Prop({ type: String, required: true })
  private sender!: string;

  @Prop({ type: String, required: true })
  private targetType!: string;

  @Prop({ type: String, required: true })
  private targetName!: string;

  @Prop({ type: Boolean, required: true })
  private isDefaultTab!: boolean;

  @Prop({ type: String, required: true })
  private outputTabName!: string;

  @Prop({ type: Boolean, required: true })
  private isSecret!: boolean;

  @VueEvent
  private onHover(type: string, flg: boolean) {
    const base = "chat-window.input-info.message-";
    this.windowInfo.message = flg
      ? LanguageManager.instance.getText(base + type)
      : "";
  }

  private get secretTarget(): string {
    return "chat-window.input-info." + (this.isSecret ? "" : "non-") + "secret";
  }
}
